import { CALL_API } from "admin/middlewares/api";

export const SME_CREATE_REQUEST = "SME_CREATE_REQUEST";
export const SME_CREATE_SUCCESS = "SME_CREATE_SUCCESS";
export const SME_CREATE_ERROR = "SME_CREATE_ERROR";

export function create_sme(postData) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/marketplace-lending/smecredit",
      authenticatedRequest: true,
      method: "POST",
      data: { ...postData },
      types: [SME_CREATE_REQUEST, SME_CREATE_SUCCESS, SME_CREATE_ERROR],
    },
  };
}

export const GET_SME_APPLICATIONS_REQUEST = "GET_SME_APPLICATIONS_REQUEST";
export const GET_SME_APPLICATIONS_SUCCESS = "GET_SME_APPLICATIONS_SUCCESS";
export const GET_SME_APPLICATIONS_ERROR = "GET_SME_APPLICATIONS_ERROR";

export function get_sme_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/SMECredit",
      authenticatedRequest: true,
      types: [
        GET_SME_APPLICATIONS_REQUEST,
        GET_SME_APPLICATIONS_SUCCESS,
        GET_SME_APPLICATIONS_ERROR,
      ],
    },
  };
}

export const SME_LIST_CHANGE_PAGE = "SME_LIST_CHANGE_PAGE";

export function change_sme_list_page(page) {
  return {
    type: SME_LIST_CHANGE_PAGE,
    page,
  };
}

export const SME_LIST_CHANGE_FILTER = "SME_LIST_CHANGE_FILTER";

export function change_sme_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: SME_LIST_CHANGE_FILTER,
    filter,
  };
}
